export const CRM_UPDATE_URL = '/v3/table-metas';
export const CRM_USER_SEARCH_URL = '/v3/users';
export const CRM_TEAM_SEARCH_URL = '/v3/departments';

export const searchCrmDepartmentParamsBuilder = (
  { search, page } = { search: '', page: 0 },
) => ({
  'filter[param][p1][name][contains]': search,
  'filter[binding]': 'p1',
  'page[number]': page,
  'page[size]': 100,
  sort: 'name',
  include: 'email_channel,phone_channel,chat_channel',
});

export const crmUpdatePath = ({ id, type }) => {
  return `${CRM_UPDATE_URL}/${type}/data/${id}`;
};

export const searchCrmUserParamsBuilder = ({ id }) => ({
  'filter[param][user][sso_profile_id][eq]': id,
  'filter[param][deactived][deactivated][eq]': true,
  'filter[param][active][deactivated][eq]': false,
  'filter[binding]': '(user&(deactived|active))',
  include: 'deps,default_department',
});

export const getCrmDepartmentOptions = (data) => {
  const options = data.reduce(
    (
      result,
      { id: value, attributes: { name: label, sso_role_id: ssoId } },
    ) => {
      if (ssoId) result.push({ label, value, ssoId });

      return result;
    },
    [],
  );

  return options;
};
